import {useQuery} from 'react-query'
import {OfferEditModalForm} from './OfferEditModalForm'
import {isNotEmpty, QUERIES} from '../../../../_metronic/helpers'
import {useListView} from '../core/ListViewProvider'
import {getBusinessCategoryById} from '../core/_requests'

const OfferEditModalFormWrapper = () => {
  const {itemIdForUpdate, setItemIdForUpdate} = useListView()
  const enabledQuery: boolean = isNotEmpty(itemIdForUpdate)
  const {
    isLoading,
    data: businessCategory,
    error,
  } = useQuery(
    `${QUERIES.BUSINESS_CATEGORY_LIST}-${itemIdForUpdate}`,
    () => {
      return getBusinessCategoryById(itemIdForUpdate)
    },
    {
      cacheTime: 0,
      enabled: enabledQuery,
      onError: (err) => {
        setItemIdForUpdate(undefined)
        console.error(err)
      },
    }
  )
  if (!itemIdForUpdate) {
    return <OfferEditModalForm isUserLoading={isLoading} businessCategory={{id: undefined}} />
  }
  if (!isLoading && !error && businessCategory) {
    return <OfferEditModalForm isUserLoading={isLoading} businessCategory={businessCategory} />
  }

  return null
}

export {OfferEditModalFormWrapper}
